import { ActionType, createReducer } from 'typesafe-actions';
import { FETCH_RELATED_PRODUCTS, RESET_RELATED_PRODUCTS } from './actions';
import { ViewsModels } from './types';

export type RelatedProductsErrorActions =
  | ActionType<typeof FETCH_RELATED_PRODUCTS.request>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.success>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.failure>
  | ActionType<typeof RESET_RELATED_PRODUCTS>;
export const relatedProductsError = createReducer<Error | null, RelatedProductsErrorActions>(null)
  .handleAction([FETCH_RELATED_PRODUCTS.failure], (_, { payload }) => payload)
  .handleAction(
    [FETCH_RELATED_PRODUCTS.request, FETCH_RELATED_PRODUCTS.success, RESET_RELATED_PRODUCTS],
    () => null,
  );

export type RelatedProductsLoadingActions =
  | ActionType<typeof FETCH_RELATED_PRODUCTS.request>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.cancel>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.success>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.failure>
  | ActionType<typeof RESET_RELATED_PRODUCTS>;
export const relatedProductsLoading = createReducer<boolean | null, RelatedProductsLoadingActions>(false)
  .handleAction([FETCH_RELATED_PRODUCTS.request], () => true)
  .handleAction(
    [
      FETCH_RELATED_PRODUCTS.success,
      FETCH_RELATED_PRODUCTS.failure,
      FETCH_RELATED_PRODUCTS.cancel,
      RESET_RELATED_PRODUCTS,
    ],
    () => false,
  );

export type RelatedProductsActions =
  | ActionType<typeof FETCH_RELATED_PRODUCTS.failure>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.cancel>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.success>
  | ActionType<typeof RESET_RELATED_PRODUCTS>;
export const relatedProducts = createReducer<ViewsModels.RelatedProducts | null, RelatedProductsActions>(
  null,
)
  .handleAction(
    [FETCH_RELATED_PRODUCTS.failure, FETCH_RELATED_PRODUCTS.cancel, RESET_RELATED_PRODUCTS],
    () => null,
  )
  .handleAction(FETCH_RELATED_PRODUCTS.success, (_, { payload }) => payload);
